module.exports = __webpack_public_path__ + "img/triangle.41e9471a.png";